module.exports = __webpack_public_path__ + "img/04-4.b7206212.png";